/* ZWIM Missed-Swim Cost tool — external (deferred). buildInputs() once at init; compute() on every keystroke. No toggles. */
(function(){
  var app=document.getElementById('ztf-app'); if(!app) return;
  var $=function(id){return document.getElementById(id);};
  function num(v){v=parseFloat((''+(v==null?'':v)).trim());return (isFinite(v)&&v>0)?v:0;}
  var I='inputmode="numeric" autocomplete="off"';
  function setHero(big,cap,unitTxt){var b=$('ztf-big');$('ztf-cap').textContent=cap;$('ztf-bigunit').textContent=unitTxt;if(b.textContent!==big){b.textContent=big;b.classList.add('pulse');setTimeout(function(){b.classList.remove('pulse');},180);if(window.__zwimTrack)window.__zwimTrack('tool_calc_run',{tool:'missed_swim'});}}
  function chips(arr){return '<div class="ztf__chips">'+arr.map(function(c){return '<div class="ztf__chip"><div class="k">'+c.k+'</div><div class="v">'+c.v+'</div></div>';}).join('')+'</div>';}
  function buildInputs(){
    var inp=$('ztf-inputs');
    inp.innerHTML='<div class="ztf__f"><label>Planned swims / week</label><input id="i-plan" value="4" '+I+'></div>'+
      '<div class="ztf__f"><label>Swims you actually hit / week</label><input id="i-act" value="2" '+I+'></div>'+
      '<div class="ztf__f"><label>Weeks until your race</label><input id="i-wks" value="12" '+I+'></div>'+
      '<div class="ztf__f"><label>Round trip to the pool (min)</label><input id="i-comm" value="40" '+I+'></div>'+
      '<div class="ztf__f"><label>Typical session length (min)</label><input id="i-dur" value="60" '+I+'></div>';
    inp.querySelectorAll('input').forEach(function(e){e.addEventListener('input',compute);});
  }
  function compute(){
    var plan=num(($('i-plan')||{}).value), act=num(($('i-act')||{}).value),
        wks=num(($('i-wks')||{}).value), comm=num(($('i-comm')||{}).value),
        dur=num(($('i-dur')||{}).value)||60, ex=$('ztf-extra');
    var missedPerWeek=Math.max(0, plan-act);
    var totalMissed=Math.round(missedPerWeek*wks);
    var poolTimeLostHrs=Math.round(totalMissed*dur/60);
    var commuteHrs=Math.round((act*wks*comm)/60);
    setHero(''+totalMissed,'Swims you’ll miss before race day','sessions');
    ex.innerHTML=chips([
      {k:'Per week',v:''+missedPerWeek},
      {k:'Pool hours lost',v:poolTimeLostHrs+' h'},
      {k:'Commute spent',v:commuteHrs+' h'}
    ]);
    $('ztf-hint').textContent='That gap is the real reason swims stall, not motivation. ZWIM closes it on the days you can’t reach the pool. Pool hours assume '+dur+' min per session.';
  }
  buildInputs(); compute();
})();
